export default class DynamicSubmenu {
    constructor() {
        this.initSubmenu();
    }

    initSubmenu() {
        const items = document.querySelectorAll('.entry .subheading'),
              submenu =  document.querySelector('.entry .submenu--dynamic');
        if (!items || !submenu) {
            return;
        }
        Array.from(items).forEach((item) => {
            let a = document.createElement("a");
                a.classList.add('submenu__item');
                a.href = '#' + item.id;
                a.appendChild(document.createTextNode(item.innerHTML));
                submenu.querySelector('.submenu__nav').appendChild(a);
        });
    }
}
  

